module.exports = __webpack_public_path__ + "static/media/arrowcircleleft.9fb7054d.svg";